import { Pagination } from '$core/models/pagination';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Blank } from '../models/blank';

@Injectable({
  providedIn: 'root',
})
export class BlanksService {
  protected apiRoute = '/batch-mailing/documents';
  protected apiVersion = '/v1';

  constructor(private readonly _http: HttpClient) {}

  public getDocuments(params: Params): Observable<Pagination<Blank>> {
    return this._http
      .get<Pagination<Blank>>(`${this.apiVersion}${this.apiRoute}`, {
        params,
      })
      .pipe(
        map((res) => {
          res.data = res.data.map((item) => new Blank(item));
          return res;
        })
      );
  }

  public getDocument(id: number): Observable<Blank> {
    return this._http.get<Blank>(`${this.apiVersion}${this.apiRoute}/${id}`);
  }

  public getDocumentFromList(id: number): Observable<Blank> {
    return this._http.get<Blank>(
      `${this.apiVersion}${this.apiRoute}/list/${id}`
    );
  }

  public removeDocuments(params: Params): Observable<unknown> {
    return this._http.post(`${this.apiVersion}${this.apiRoute}-delete`, params);
  }

  public downloadPrivateDocuments(ids: number[]): Observable<any> {
    return forkJoin(
      ids.map((id) =>
        this._http.get(`${this.apiVersion}${this.apiRoute}/${id}/download`, {
          responseType: 'arraybuffer',
          observe: 'response',
        })
      )
    ).pipe(
      tap((files: HttpResponse<ArrayBuffer>[]) => {
        files.forEach((fileRes) => {
          const cd = fileRes.headers.get('content-disposition');
          const fileName = cd.match(/filename="?(.*?[^";]*)/i)[1] || 'file.pdf';
          const blob = new Blob([fileRes.body]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = fileName;
          a.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            a.remove();
          }, 1000);
        });
      })
    );
  }
}
